
<div class="btn-bar" #buttonBar>

  @if (canDisplayCloseFormButton()) {
    <button class="btn btn-outline-secondary" type="button"
      (click)="hideForm()"
      translate>common.close
    </button>
  }

  @if (canDisplayCancelBookingButton()) {
    <button type="submit" class="btn btn-outline-danger"
      (click)="cancelBooking()"
      translate>services.craning.booking.actions.cancelBooking
    </button>
  }

  @if (canDisplayPrintBookingButton()) {
    <button type="submit" class="btn btn-outline-secondary"
      (click)="printBooking()"
      translate>services.craning.booking.actions.printBooking
    </button>
  }

  @if (canDisplayModifyButton()) {
    <button class="btn btn-primary" type="button"
      (click)="openUpdateMode()"
      translate>common.modify
    </button>
  }

  @if (canDisplayBillButton()) {
    <button class="btn btn-primary" type="button"
      (click)="openBillingMode()"
      translate>common.bill
    </button>
  }

  @if (canDisplayDownloadButton()) {
    <button class="btn btn-primary" type="button"
      (click)="downloadBillReport()"
      translate>services.craning.booking.actions.download
    </button>
  }

  @if (canDisplayCreateButton()) {
    <button class="btn btn-primary" type="button"
      (click)="openCreateMode(true)"
      translate>services.craning.booking.actions.addBooking
    </button>
  }
</div>

<app-craning-booking-form [service]="service"
  [selectedSlot]="selectedSlot"
  [selectedBooking]="selectedBooking"
  [crtLang]="crtLang"
  [mode]="formMode"
  (bookingBilled)="craningBookingBilled($event)"
(bookingSaved)="craningBookingSaved($event)"></app-craning-booking-form>

@if (canDisplayCalendar()) {
  <app-craning-booking-calendar #calendar
    [crtLang]="crtLang"
    [serviceId]="service.serviceId"
  (selectedSlot)="selectSlot($event)"></app-craning-booking-calendar>
}

@if (craningBookingUtils.isExploitantView() && formMode === CraningBookingFormMode.Hidden) {
  <div class="btn-bar">
    <button class="btn btn-primary" type="button"
      (click)="openSlotGenerationModal()"
      translate>services.craning.slots.actions.generate
    </button>
    <button class="btn btn-primary" type="button"
      (click)="openSlotDeletionModal()"
      translate>services.craning.slots.actions.delete
    </button>
  </div>
}
